export class ServiceUnavailable extends Error {
  constructor(response) {
    super()
    this.response = response
    this.name = this.constructor.name
  }
}
